import * as React from "react";
import { useEffect, useState } from "react";

import "./button-view-cart.less";
import { ModalComponent } from "shared/components/modal/modal";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "app.hook";
import { shallowEqual, useSelector } from "react-redux";
import { ItemModalViewCart } from "./components/item-view-cart";
import { selectShoppingCart, showViewCartModal } from "states/shopping-cart/shopping-cart.slice";
import { nanoid } from "@reduxjs/toolkit";
import { CHECKOUT_ROUTE, VIEW_MENU_ROUTE } from "shared/constants/routes";
import { IconBasket, IconShoppingBag } from "themes";
import { selectSignIn, showOrderGuestModal } from "states/global-value/global-value.slice";
import { formatMoney } from "shared/plugins/string-helper";

export function ButtonModalViewCart() {
  const currentShoppingCart = useAppSelector(selectShoppingCart, shallowEqual);
  const isLogged = useSelector(selectSignIn, shallowEqual);
  const location = useLocation();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const [modalIsOpen, setIsOpen] = useState<boolean>(false);

  // const handleOpenModal = () => {
  //   setIsOpen(true);
  // };
  // const handleCloseModal = () => {
  //   setIsOpen(false);
  // };

  const totalItems = currentShoppingCart?.items?.reduce((sum, item) => sum + item.quantity, 0) || 0;

  return (
    <>
      <button
        onClick={() => { dispatch(showViewCartModal()) }}
        className="btn--default button-view-cart-desktop rounded  px-8 py-8 space-y-1 btn--primary fixed bottom-20 right-1"
      >
        <span className="flex">
          <IconBasket width={20} /> CART ({totalItems})
        </span>
      </button>

    </>
  );
}
